import { useMemo, useState } from "react";

import {
  Button,
  Icon,
  QuestionFilledSVG,
  QuestionHollowSVG,
} from "@newsela/angelou";

import { NavButtonWithPopout } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/NavButtonWithPopout";
import {
  getNavMenuButtonAriaProps,
  IButtonAriaProps,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/NavButtonWithPopout/NavButtonWithPopout.utils";
import {
  questionIconCss,
  supportCenterButtonCss,
  supportCenterVisibilityCss,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/SupportCenter/SupportCenter.styles";
import { SupportCenterPopout } from "@/base/NewselaGlobalLayoutV2/NavigationBar/SupportCenter/SupportCenterPopout";
import useUser from "@/users/useUser";

const MENU_ID = "nav-support-center";

const SupportCenter = () => {
  const { data: user } = useUser();

  const [isOpen, setIsOpen] = useState(false);

  const buttonAriaProps: IButtonAriaProps = useMemo(
    () =>
      getNavMenuButtonAriaProps({
        isOpen,
        id: MENU_ID,
        ariaLabel: "Support Center Menu",
      }),
    [isOpen],
  );

  if (!user?.is_authenticated) return null;

  const onClickButton = () => setIsOpen((isOpen) => !isOpen);

  return (
    <NavButtonWithPopout
      id={MENU_ID}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      position={{ top: "3.6rem", right: "0rem" }}
      rootCustomCss={supportCenterVisibilityCss}
      ButtonComponent={
        <Button
          onClick={onClickButton}
          ariaProps={buttonAriaProps}
          flavor={Button.flavors.incognito}
          __cssFor={supportCenterButtonCss}
          dataProps={{ "data-qa-selector": "global-nav-support-menu" }}
        >
          {isOpen ? (
            <Icon SvgComponent={QuestionFilledSVG} __cssFor={questionIconCss} />
          ) : (
            <Icon SvgComponent={QuestionHollowSVG} __cssFor={questionIconCss} />
          )}
        </Button>
      }
      PopoutComponent={<SupportCenterPopout />}
    />
  );
};

SupportCenter.displayName = "SupportCenter";
export { SupportCenter };
